var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEdit = function SvgEdit(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.75,
    d: "M11.273 2.968 13.017 4.7zm1.122-1.524L7.678 6.126c-.244.241-.41.55-.478.884l-.435 2.165 2.18-.433c.338-.067.648-.232.892-.474l4.716-4.682a1.51 1.51 0 0 0 .33-1.65 1.51 1.51 0 0 0-.825-.82 1.54 1.54 0 0 0-1.663.328"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.75,
    strokeWidth: 1.2,
    d: "M13.353 10.912v2.452c0 .434-.173.85-.482 1.156a1.65 1.65 0 0 1-1.165.48H2.647c-.437 0-.856-.173-1.165-.48A1.63 1.63 0 0 1 1 13.364V4.371c0-.433.174-.85.482-1.156a1.65 1.65 0 0 1 1.165-.479h2.47"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };